// extracted by mini-css-extract-plugin
module.exports = {"sellers-footer-link":"SellersFooter_sellers-footer-link__WvH5N"};